import React from 'react'
import Circle from '../../three/components/Circle'
import { Math as ThreeMath } from 'three'
import usePuzzleStore from '../hooks/usePuzzleStore'
import {
  sumArrays,
  getConnectionsForPieceId
} from '../util'

const getPiecePointPosition = (connection, pieceId) => {
  if (connection.p1.id === pieceId)
    return connection.p1.position
  if (connection.p2.id === pieceId)
    return connection.p2.position
  throw new Error('piece id is not in connection')
}

/**
 * Helper component to show connection points on piece
 */
function ConnectionHelpers({
  id,
  basePosition = [0, 0, 0],
  rotation = [
    ThreeMath.degToRad(90),
    ThreeMath.degToRad(180),
    0
  ]
}) {
  const active = usePuzzleStore(state => state.active)
  const snapRadius = usePuzzleStore(
    state => state.snapRadius
  )
  const connections = getConnectionsForPieceId(
    active.connections,
    id
  )
  return (
    <>
      {connections.map((c, i) => (
        <Circle
          key={'cp-' + i}
          position={sumArrays(
            basePosition,
            getPiecePointPosition(c, id)
          )}
          radius={snapRadius}
          rotation={rotation}
          color={0x64b964}
        />
      ))}
    </>
  )
}

export default ConnectionHelpers
